export default function CancelPage() {
  return (
    <div
      style={{
        padding: "40px",
        textAlign: "center",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <h1 style={{ color: "#4CAF50" }}>Payment Cancelled! ✅</h1>
      <p>Sorry, your payment has been Cancelled. Please try again.</p>
      <button
        onClick={() => window.close()}
        style={{
          padding: "10px 20px",
          backgroundColor: "#007cba",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Close Window
      </button>
    </div>
  );
}
